// extracted by mini-css-extract-plugin
export default {"showMobile":"BusinessInfoStep-module-showMobile-21KrW"};